"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var LoaderShelf = /** @class */ (function () {
    function LoaderShelf() {
        this._loading = false;
        mobx_1.makeObservable(this, {
            _loading: mobx_1.observable,
            start: mobx_1.action,
            end: mobx_1.action,
            tryStart: mobx_1.action,
            isLoading: mobx_1.computed,
        });
    }
    LoaderShelf.prototype.tryStart = function (errorMessage) {
        if (errorMessage === void 0) { errorMessage = "Still Loading"; }
        if (this.isLoading) {
            throw Error(errorMessage);
        }
        this.start();
    };
    LoaderShelf.prototype.start = function () {
        this._loading = true;
    };
    LoaderShelf.prototype.end = function () {
        this._loading = false;
    };
    Object.defineProperty(LoaderShelf.prototype, "isLoading", {
        get: function () {
            return this._loading;
        },
        enumerable: false,
        configurable: true
    });
    return LoaderShelf;
}());
exports.default = LoaderShelf;
